import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import * as _screenfull from 'screenfull';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

/** Screenfull typings are wrong, so we override them */
const screenfull = _screenfull as any;

@Component({
    selector: 'fury-toolbar-fullscreen-toggle',
    templateUrl: './toolbar-fullscreen-toggle.component.html',
    styleUrls: ['./toolbar-fullscreen-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarFullscreenToggleComponent extends BaseComponent implements OnInit {

  public isFullscreen = false;

  constructor(private _cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    screenfull.on('change', () => this.setFullscreen(screenfull.isFullscreen));
  }

  toggleFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
      this.setFullscreen(screenfull.isFullscreen);
    }
  }

  setFullscreen(isFullscreen: boolean) {
    this.isFullscreen = isFullscreen;
    this._cd.markForCheck();
  }
}
